import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

import {
  fetchPageDataCreateTripReview,
  type IPageDataCreateTripReviewRequest,
  type TPageDataCreateTripReviewResponse,
} from '../../repositories/dailyrent/v1/page-data/create-trip-review';
import { ITripInfo } from '../../repositories/dailyrent/entities/response/TripInfo';
import { ENewReviewFlow, EStartReviewErrorCode } from '../../types/newReview';
import type { IErrorResponseSchema } from '../../repositories/dailyrent/entities/schemas/ErrorResponseSchema';
import { mapTripStatusToFlow } from '../../utils/newReview/mapTripStatusToFlow';

interface IFetchCreateTripReviewPageDataParams {
  httpApi: IHttpApi;
  logger: ILogger;
  parameters: IPageDataCreateTripReviewRequest;
}

interface ICreateTripReviewPageDataResult {
  tripInfo: ITripInfo | null;
  flow: ENewReviewFlow | null;
  errorCode: EStartReviewErrorCode | null;
}

async function fetchCreateTripReviewPageDataRaw({
  httpApi,
  parameters,
}: IFetchCreateTripReviewPageDataParams): Promise<ICreateTripReviewPageDataResult> {
  const result: TPageDataCreateTripReviewResponse = await fetchPageDataCreateTripReview({
    httpApi,
    parameters,
  });

  if (result.statusCode !== 200) {
    const error = (result.response as IErrorResponseSchema)?.errors?.[0] as { code: EStartReviewErrorCode } | undefined;

    return {
      tripInfo: null,
      flow: null,
      errorCode: error?.code ?? EStartReviewErrorCode.Unknown,
    };
  }

  return {
    tripInfo: result.response.tripInfo,
    flow: mapTripStatusToFlow(result.response.tripStatusStep?.tripStatus),
    errorCode: null,
  };
}

async function fetchCreateTripReviewPageDataSafe(
  args: IFetchCreateTripReviewPageDataParams,
): Promise<ICreateTripReviewPageDataResult> {
  try {
    return fetchCreateTripReviewPageDataRaw(args);
  } catch (error) {
    args.logger.error(error, {
      comment: '[Degradation] Ошибка получения данных для формы создания отзыва',
    });

    return {
      tripInfo: null,
      flow: null,
      errorCode: EStartReviewErrorCode.Unknown,
    };
  }
}

export { fetchCreateTripReviewPageDataSafe as fetchCreateTripReviewPageData };
